export const CONSTANTS = {
  FIRST_GAME_DATE: '2025-10-30',
  FEEDBACK_LINK:
    'https://docs.google.com/forms/d/e/1FAIpQLSclRSi-abOfJSMM1w9EmCXGo7IOwK6FZENTEKr9in62IJIqpA/viewform?usp=header',
};
